module.exports = __webpack_public_path__ + "static/media/view award.136ac00a.svg";